"use strict";

const MelissaExpressAddress = require('./melissa-express-address');

module.exports = class {
    #id;
    #melissaExpressAddress;

    $form;
    $streetAddressContainer;
    $streetAddressField;
    $cityField;
    $countyField;
    $stateField;
    $zipCodeField;
    $resultCodeField;
    
    constructor(args) {
        this.$form = args.$form ?? null;

        if (!this.$form || this.$form.length === 0) {
            return null;
        }

        this.#id = args.id ?? this.$form.attr('id') ?? null;

        this.$streetAddressContainer = this.$form.find('.gfield.melissa-street-address') ?? null;

        if (!this.$streetAddressContainer || this.$streetAddressContainer.length === 0) {
            return null;
        }

        this.$streetAddressField = this.$form.find('.gfield.melissa-street-address input') ?? null;
        this.$cityField = this.$form.find('.gfield.melissa-city input') ?? null;
        this.$countyField = this.$form.find('.gfield.melissa-county input') ?? null;
        this.$stateField = this.$form.find('.gfield.melissa-state select') ?? null;
        this.$zipCodeField = this.$form.find('.gfield.melissa-zip-code input') ?? null;
        this.$resultCodeField = this.$form.find('.gfield.melissa-result-code input') ?? null;

        this.bind();

        this.#melissaExpressAddress = new MelissaExpressAddress({
            id: this.id,
            $form: this.$form,
            $streetAddressField: this.$streetAddressField,
            $cityField: this.$cityField,
            $stateField: this.$stateField,
            $countyField: this.$countyField,
            $zipCodeField: this.$zipCodeField,
            $resultCodeField: this.$resultCodeField
        });
    }

    bind() {
        this.$form.on(`melissa-express-address:insert-dropdown:${this.id}`, (event, data) => {
            this.onInsertDropdown(event, data);
        });

        this.$form.on(`melissa-express-address:updated-results:${this.id}`, (event, data) => {
            this.onUpdatedResults(event, data);
        });

        this.$form.on(`melissa-express-address:selected-address:${this.id}`, (event, data) => {
            this.onSelectedAddress(event, data);
        });

        this.$form.on(`melissa-express-address:result-code-error:${this.id}`, (event, data) => {
            this.onResultCodeError(event, data);
        });
    }

    get id() {
        return this.#id;
    }

    get melissaExpressAddress() {
        return this.#melissaExpressAddress;
    }

    onInsertDropdown(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }

        this.$streetAddressContainer.find('.ginput_container').append(data.$dropdown);
    }

    onUpdatedResults(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }

    onSelectedAddress(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }

    onResultCodeError(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }
}